import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function getProviders(params: any = {}) {
  return request({
    url: 'providers/',
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function getAllProviders(params: any = {}) {
  return request({
    url: 'providers/',
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function getProvidersDetail(params: any = {}) {
  return request({
    url: 'providers/',
    method: 'GET',
    params,
  }) as AxiosPromise;
}

export async function getProvider(id: number | string) {
  return request({
    url: `providers/${id}/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function updateProvider(id: number | string, data: any) {
  return request({
    url: `providers/${id}/`,
    method: 'PATCH',
    data,
  }) as AxiosPromise;
}

export async function getPharmacy(id: number | string) {
  return request({
    url: `pharmacy/${id}/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function updatePharmacy(id: number | string, data: any) {
  return request({
    url: `pharmacy/${id}/`,
    method: 'PATCH',
    data,
  }) as AxiosPromise;
}

export async function getProviderDetailByType(provider: any) {
  return request({
    url: `providers/${provider?.id}/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function updateProviderByType(provider: any, data: any) {
  return request({
    url: `providers/${provider?.id}/`,
    method: 'PATCH',
    data,
  }) as AxiosPromise;
}

export async function getProviderCBUs(providerId: number | string) {
  return request({
    url: `providers/${providerId}/cbus/`,
    method: 'GET',
  }) as AxiosPromise;
}

export async function createProviderCBU(providerId: number | string, data: any) {
  return request({
    url: `providers/${providerId}/cbus/`,
    method: 'POST',
    data,
  }) as AxiosPromise;
}
